import React, { useState, useEffect } from "react";
import "./EditProductModal.css";
import { doc, updateDoc, collection, getDocs } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

const EditProductModal = ({ product, onClose, onSave }) => {

const COLOR_MAP = {
  crna: "#000000",
  bijela: "#ffffff",
  siva: "#9e9e9e",
  plava: "#1976d2",
   "tamno plava": "#0d47a1",
  crvena: "#d32f2f",
  zelena: "#388e3c",
  žuta: "#fbc02d",
  braon: "#6d4c41",
  roze: "#d81b60",
   "svjetlo roze": "#f8bbd0",
  ljubicasta: "#7b1fa2",
};

  const getSizeList = (velicine) =>
    Array.isArray(velicine)
      ? velicine
          .map((v) => (typeof v === "object" ? v.broj : v))
          .filter(Boolean)
      : [];

  const getDoplataForRange = (velicine, predicate) => {
    if (!Array.isArray(velicine)) return "";
    const match = velicine.find(
      (v) => typeof v === "object" && predicate(Number(v.broj))
    );
    return match ? String(Number(match.doplata || 0)) : "";
  };

  const [formData, setFormData] = useState({
    ...product,
    subkategorije: Array.isArray(product.subkategorije)
      ? product.subkategorije.join(", ")
      : product.subkategorije || "",
    velicine: Array.isArray(product.velicine)
      ? product.velicine.join(", ")
      : product.velicine || "", // dodano polje za velicine
        boje: Array.isArray(product.boje)
    ? product.boje.join(", ")
    : product.boje || "",
    nacinUpotrebe: product.nacinUpotrebe || "",
    sastav: product.sastav || "",
    brandId: product.brandId || "", // za brand
    novo: product.novo || false,
    naAkciji: product.naAkciji || false,
    akcijaOdKolicine: product.akcijaOdKolicine || 4,
    akcijaPopustPovecani: product.akcijaPopustPovecani || 25,
    doplata4748: getDoplataForRange(product.velicine, (n) => n >= 47 && n <= 48),
    doplata4950: getDoplataForRange(product.velicine, (n) => n >= 49 && n <= 50),
  });

  const [selectedSizes, setSelectedSizes] = useState(
  getSizeList(product.velicine)
);

const [selectedColors, setSelectedColors] = useState(
  Array.isArray(product.boje) ? product.boje : []
);
  const [brands, setBrands] = useState([]);
  const [newImageFile, setNewImageFile] = useState(null);
  const [saving, setSaving] = useState(false);

  // Učitaj brendove iz Firestore
  useEffect(() => {
    const fetchBrands = async () => {
      const brandsSnapshot = await getDocs(collection(db, "brands"));
      const brandsList = brandsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBrands(brandsList);
    };
    fetchBrands();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;
    setFormData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) setNewImageFile(file);
  };

  const toggleSize = (size) => {
  setSelectedSizes((prev) =>
    prev.includes(size)
      ? prev.filter((s) => s !== size)
      : [...prev, size]
  );
};

const toggleColor = (color) => {
  setSelectedColors((prev) =>
    prev.includes(color)
      ? prev.filter((c) => c !== color)
      : [...prev, color]
  );
};

  const handleSave = async () => {
    setSaving(true);
    try {
      let updatedData = { ...formData };

      if (!updatedData.naPopustu) {
        updatedData.popustProcenat = 0;
      } else {
        // Ako je na popustu, obezbedi da bude broj
        updatedData.popustProcenat =
          parseFloat(updatedData.popustProcenat) || 0;
      }

      if (!updatedData.naAkciji) {
        updatedData.akcijaOdKolicine = 4;
        updatedData.akcijaPopustPovecani = 25;
      } else {
        updatedData.akcijaOdKolicine =
          parseInt(updatedData.akcijaOdKolicine, 10) || 4;
        updatedData.akcijaPopustPovecani =
          parseFloat(updatedData.akcijaPopustPovecani) || 25;
      }

      // Upload nove slike ako postoji
      if (newImageFile) {
        const storageRef = ref(storage, `images/${product.id}`);
        await uploadBytes(storageRef, newImageFile);
        const imageUrl = await getDownloadURL(storageRef);
        updatedData.slikaURL = imageUrl;
      }

      // Konvertuj podkategorije iz stringa u niz
      if (typeof updatedData.subkategorije === "string") {
        updatedData.subkategorije = updatedData.subkategorije
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s.length > 0);
      }

     // Ako je obuća — uzmi vrijednosti iz UI state-a
if (updatedData.kategorija?.toLowerCase() === "obuća") {
  updatedData.velicine = selectedSizes.map((size) => {
    const sizeNum = Number(size);
    const doplata =
      sizeNum >= 49
        ? Number(formData.doplata4950 || 0)
        : sizeNum >= 47
          ? Number(formData.doplata4748 || 0)
          : 0;
    return { broj: size, doplata };
  });
  updatedData.boje = selectedColors;
}

      const productRef = doc(db, "products", product.id);
      await updateDoc(productRef, updatedData);

      if (onSave) onSave();
      onClose();
    } catch (err) {
      console.error("Greška pri snimanju proizvoda:", err);
      alert("Greška pri snimanju proizvoda.");
    }
    setSaving(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Izmeni proizvod</h2>

        <label>Šifra</label>
        <input
          type="text"
          name="sifra"
          value={formData.sifra || ""}
          onChange={handleChange}
        />

        <label>Naziv</label>
        <input
          type="text"
          name="naziv"
          value={formData.naziv || ""}
          onChange={handleChange}
        />

        <label>Cijena</label>
        <input
          type="number"
          name="cijena"
          value={formData.cijena || ""}
          onChange={handleChange}
        />

        <label>Kategorija</label>
        <input
          type="text"
          name="kategorija"
          value={formData.kategorija || ""}
          onChange={handleChange}
        />

        <label>Podkategorije (odvojene zarezom)</label>
        <input
          type="text"
          name="subkategorije"
          value={formData.subkategorije}
          onChange={handleChange}
          placeholder="npr. podkategorija1, podkategorija2"
        />

       {formData.kategorija?.toLowerCase() === "obuća" && (
  <>
    {/* ===== VELIČINE ===== */}
    <label>Veličine (klikni da označiš)</label>
    <div className="size-list">
      {["36", "37", "38","39", "40", "41", "42", "43", "44", "45" , "46" , "47", "48",
        "49", "50"
      ].map((size) => (
        <button
          type="button"
          key={size}
          className={`size-btn ${
            selectedSizes.includes(size) ? "selected" : ""
          }`}
          onClick={() => toggleSize(size)}
        >
          {size}
        </button>
      ))}
    </div>

    {/* ===== DOPLATE ===== */}
    <label>Doplata za brojeve 47-48 (BAM)</label>
    <input
      type="number"
      name="doplata4748"
      value={formData.doplata4748 || ""}
      onChange={handleChange}
      min="0"
      step="0.01"
    />

    <label>Doplata za brojeve 49-50 (BAM)</label>
    <input
      type="number"
      name="doplata4950"
      value={formData.doplata4950 || ""}
      onChange={handleChange}
      min="0"
      step="0.01"
    />

    {/* ===== BOJE ===== */}
    <label>Boje</label>
    <div className="color-list">
      {Object.entries(COLOR_MAP).map(([name, hex]) => (
        <label key={name} className="color-item">
          <input
            type="checkbox"
            checked={selectedColors.includes(name)}
            onChange={() => toggleColor(name)}
          />
          <span
            className="color-dot"
            style={{ backgroundColor: hex }}
          />
          {name}
        </label>
      ))}
    </div>
  </>
)}

        <label>Brand</label>
        <select name="brandId" value={formData.brandId} onChange={handleChange}>
          <option value="">-- Izaberite brand --</option>
          {brands.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </select>

        <label>Na popustu</label>
        <input
          type="checkbox"
          name="naPopustu"
          checked={formData.naPopustu || false}
          onChange={handleChange}
        />

        {formData.naPopustu && (
          <>
            <label>Procenat popusta</label>
            <input
              type="number"
              name="popustProcenat"
              value={formData.popustProcenat || ""}
              onChange={handleChange}
            />
          </>
        )}

        <label>Akcija na kolicinu</label>
        <input
          type="checkbox"
          name="naAkciji"
          checked={formData.naAkciji || false}
          onChange={handleChange}
        />

        {formData.naAkciji && (
          <>
            <label>Veci popust od kolicine</label>
            <input
              type="number"
              name="akcijaOdKolicine"
              value={formData.akcijaOdKolicine || 4}
              onChange={handleChange}
              min="1"
            />

            <label>Novi popust od te kolicine (%)</label>
            <input
              type="number"
              name="akcijaPopustPovecani"
              value={formData.akcijaPopustPovecani || ""}
              onChange={handleChange}
              min="0"
              max="100"
            />
          </>
        )}

        <label>Na stanju</label>
        <input
          type="checkbox"
          name="naStanju"
          checked={formData.naStanju || false}
          onChange={handleChange}
        />

        <label>Novo</label>
        <input
          type="checkbox"
          name="novo"
          checked={formData.novo || false}
          onChange={handleChange}
        />

        <label>Opis</label>
        <textarea
          name="opis"
          value={formData.opis || ""}
          onChange={handleChange}
        />

        <label>Način upotrebe</label>
        <textarea
          name="nacinUpotrebe"
          value={formData.nacinUpotrebe || ""}
          onChange={handleChange}
        />

        <label>Sastav</label>
        <textarea
          name="sastav"
          value={formData.sastav || ""}
          onChange={handleChange}
        />

        <label>Slika</label>
        <input type="file" accept="image/*" onChange={handleImageChange} />

        <div className="modal-actions">
          <button onClick={onClose} className="cancel-btn">
            Otkaži
          </button>
          <button onClick={handleSave} disabled={saving} className="save-btn">
            {saving ? "Čuva se..." : "Sačuvaj"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProductModal;


